import { cn } from '@latitude/token-utils';
import * as ToastPrimitives from '@radix-ui/react-toast';
import type { ComponentPropsWithoutRef, ComponentRef, Ref } from 'react';

/**
 * Represents the description of a toast.
 *
 * @component
 * @example
 * ```tsx
 * <ToastDescription className="my-toast-description" />
 * ```
 */
export const ToastDescription = ({
  className,
  ref,
  ...props
}: ComponentPropsWithoutRef<typeof ToastPrimitives.Description> & {
  ref?: Ref<ComponentRef<typeof ToastPrimitives.Description>>;
}) => (
  <ToastPrimitives.Description
    ref={ref}
    data-toast-description
    className={cn(
      [
        'break-words',
        'line-clamp-3',
        'text-ellipsis',
        'overflow-hidden',
        'whitespace-normal',
        'font-ref-web-body-regular-font-family',
        'font-ref-web-body-regular-font-weight',
        'text-font-ref-caption-regular-font-size',
        'tracking-font-ref-web-body-regular-letter-spacing',
        'leading-ref-web-body-regular-line-height',
      ],
      className,
    )}
    {...props}
  />
);
ToastDescription.displayName = ToastPrimitives.Description.displayName;
